export default __webpack_public_path__ + "static/Pyszne for business horizontal RGB Orange-9b319ec8f43ddea5f3ecc22bc0177152.png";